import React from 'react';
import { Box, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

import {
  TrussEnvelopeSnappingBehaviorMode,
  TrussEnvelopeSnappingSettings,
} from '../../../../../library/layout-geometry/truss-envelopes/types';
import { layoutSlice } from '../../../../../store/slices/layoutSlice';
import { useAppDispatch } from '../../../../hooks';
import { SnappingSettingsTooltip } from './SnappingSettingsTooltip';
import { TrussEnvelopeSnappingDistanceField } from './TrussEnvelopeSnappingDistanceField';

export function TrussEnvelopeSnappingConfiguration(props: {
  configuredSettings: TrussEnvelopeSnappingSettings;
  actualSettings: TrussEnvelopeSnappingSettings | null;
}) {
  const dispatch = useAppDispatch();

  return (
    <Stack direction="column" spacing={1}>
      <Box>
        <Typography gutterBottom variant="subtitle2">
          Snapping Behavior
        </Typography>

        <ToggleButtonGroup
          exclusive
          size="small"
          value={props.configuredSettings.behaviorMode}
          onChange={(_, value: TrussEnvelopeSnappingBehaviorMode | null) => {
            if (value == null) return;
            dispatch(layoutSlice.actions.trussEnvelopeSnappingBehaviorSet(value));
          }}
        >
          <SnappingSettingsTooltip title="Envelope will be snapped against the base line closest to your mouse.">
            <ToggleButton value="closest-target">Closest Base</ToggleButton>
          </SnappingSettingsTooltip>

          <SnappingSettingsTooltip title="The closest possible envelope to your mouse position will be chosen.">
            <ToggleButton value="closest-result">Best Envelope</ToggleButton>
          </SnappingSettingsTooltip>
        </ToggleButtonGroup>
      </Box>

      <Box sx={{ marginTop: 1 }}>
        <SnappingSettingsTooltip title="Allowed snapping distances. Enter a single or multiple comma separated distances, or leave bank to automatically choose.">
          <TrussEnvelopeSnappingDistanceField
            configuredSettings={props.configuredSettings}
            actualSettings={props.actualSettings}
          />
        </SnappingSettingsTooltip>
      </Box>
    </Stack>
  );
}
